module.exports = __webpack_public_path__ + "static/media/banner2.213ab0e5.png";